import { render, staticRenderFns } from "./EditorialPersonnel.vue?vue&type=template&id=03fa9f9e&scoped=true"
import script from "./EditorialPersonnel.vue?vue&type=script&lang=js"
export * from "./EditorialPersonnel.vue?vue&type=script&lang=js"
import style0 from "./EditorialPersonnel.vue?vue&type=style&index=0&id=03fa9f9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa9f9e",
  null
  
)

export default component.exports